// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"16b10795","506":"00ecb02d","580":"22c761c1","961":"ce9e0609","992":"6f864c2d"}[chunkId] + ".chunk.js";
};